<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span>Power Up Your Gaming Platform with Minglepay’s Payment Gateway</div>
            <div class="banner_tips mt-40 fw-300">Level up your online gaming experience with Minglepay’s cutting-edge payment solutions. Designed for the gaming industry, our platform delivers fast, secure, and seamless transactions that connect players and publishers like never before.</div>
         </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Why Minglepay for Online Gaming?</div>
                <div class="title_tag color6">Game-Changing Payment Features</div>
            </div>
          <div class="py-20" v-for="item in list1" :key="item.id">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center bg_9" :class="[item.id%2==0?'order-2':'']">
                   
                    <div class="tab_left text-l p-20 " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">{{ item.title }}</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">{{ item.msg }}</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container page_title_bag page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">Unlock Player Potential with Data Enrichment</div>
                <div class="title_tag color1">Our Data Enrichment service provides secure, compliant access to player bank data, revealing spending behaviors that drive revenue. Proven to double revenue for platforms using banking insights, it’s your key to smarter business decisions.</div>
            </div>
        </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Seamless Real-Time Payments & Payouts</div>
                <div class="title_tag color6">With Minglepay’s Open Banking infrastructure, you can:</div>
            </div>
          <div class="py-20" v-for="item in list2" :key="item.id">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center bg_9" :class="[item.id%2==0?'order-2':'']">
                   
                    <div class="tab_left text-l p-20 " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">{{ item.title }}</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">{{ item.msg }}</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
 
    <div class="container bg-6 page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">No-Code Payment Pages for Instant Sales</div>
                <div class="title_tag color1">Turn your gaming community into a revenue powerhouse. Create custom payment pages without coding or complex integrations. Share deals across streams, socials, or in-game, and watch sales soar.</div>
            </div>
        </div>
    </div>
    
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="py-20" >
            <div class="page_title pt-30">
                <div class="title_name color2 ">FAQs</div>
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_8 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How fast are payments processed?" name="1">
                            <div class="coll_item">Payments and payouts are processed instantly, with funds reflecting in accounts within minutes.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is Minglepay’s platform secure for gaming?" name="2">
                           <div class="coll_item">Yes, we use advanced encryption and AI-driven fraud detection to ensure every transaction is safe.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can I customize payment pages for my game?" name="3">
                           <div class="coll_item">Absolutely! Our no-code payment pages let you create tailored deals to match your brand and audience</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t20.png" alt="">
                  </div>
                </div>

            </div>
          </div>
          <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t40.png" alt="">
                  </div>
                </div>
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color2 text-l">Tools to Transform Your SaaS Business</div>
                        <div class="title_tag color6 text-l">Experience the power of instant transactions, actionable analytics, and secure payment processing. With Minglepay, your SaaS platform can focus on innovation and growth while we take care of the payments.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon1 from '../../assets/image/t33.png'
import icon2 from '../../assets/image/t34.png'
import icon3 from '../../assets/image/t35.png'
import icon4 from '../../assets/image/t36.png'

import icon5 from '../../assets/image/t37.png'
import icon6 from '../../assets/image/t38.png'
import icon7 from '../../assets/image/t39.png'

export default {
    data(){
        return{
            list1:[
                {title:"Data-Driven Insights",msg:"Unlock player spending patterns with our secure Data Enrichment service, turning bank data into actionable strategies.",img:icon1,id:1,},
                {title:"Instant Pay & Go",msg:"Enable players to make direct, secure payments from their bank accounts with real-time processing.",img:icon2,id:2,},
                {title:"Real-Time Payouts",msg:"Offer on-demand payouts to keep players and publishers engaged with instant fund access.",img:icon3,id:3,},
                {title:"No-Code Payment Pages",msg:"Transform any gaming stream into a revenue channel with customizable, integration-free payment pages.",img:icon4,id:4,},
            ],
            list2:[
                {title:"Accept Payments Instantly",msg:"Players pay directly from their bank accounts with secure, real-time transactions.",img:icon5,id:1,},
                {title:"Enable Fast Payouts",msg:"Deliver winnings or rewards to players instantly, boosting engagement and trust.",img:icon6,id:2,},
                {title:"Expand Globally",msg:"Connect with leading banks across the UK, EU, and beyond for effortless transactions.",img:icon7,id:3,},
               
            ],
         
            activeName:'1',
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/db_bg5.png);
}
.bg-6{
    background-image:url( ../../../public/bg/bg6.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.title_line{
    width: 120px;
    position: relative;
    &::before{
        content:'';
        width: 20px;
        background:$theme_color3;
        position: absolute;
        right: -38px;
        height: 10px;
    }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
</style>